$(function() {

    // Close popup
    $(document).on('click', '.popup__close', function (e) {
        e.preventDefault();
        $(this).removeClass('is-active');
        $(this).closest('.popup').removeClass('popup--show');
        $('html').removeClass('no-scroll');
    });

    // Open popup
    // Buttons or links
    $(document).on('click', '[data-toggle="popup"]', function (e) {
        e.preventDefault();
        launchPopup(this);
    });

    // Forms
    $(document).on('submit', '[data-toggle="popup-submit"]', function (e) {
        e.preventDefault();
        launchPopup(this);
    });

    // Go to next element in multi item popup
    $(document).on('click', '[data-toggle="popup-multi-next"]', function (e) {
        e.preventDefault();
        nextInPopup(this);
    });

    // If page is reloded with open popup
    if(document.getElementsByClassName('popup--show').length) {
        $('html').addClass('no-scroll');
    }
});

// Opens popup window
function launchPopup(elem) {

    var target = null;

    if(elem.dataset && elem.dataset.target)
        target = elem.dataset.target;
    else if(elem.getAttribute('data-target'))
        target = elem.getAttribute('data-target'); // IE not supporting dataset
    else
        target = elem.getAttribute("href");

    $(target).addClass('popup--show');

    // Wait a bit, because animation works only after display:none is removed
    setTimeout(function() {
        $(target).find('.popup__close').addClass('is-active');
    }, 12);

    $('html').addClass('no-scroll');
}

// Slides to next item if popup contains multi item block
function nextInPopup(elem) {

    var target = null;

    if(elem.dataset && elem.dataset.target)
        target = elem.dataset.target;
    else if(elem.getAttribute('data-target'))
        target = elem.getAttribute('data-target'); // IE not supporting dataset
    else
        target = elem.getAttribute("href");

    $('.popup__multi-item--show').removeClass('popup__multi-item--show');

    $(target).addClass('popup__multi-item--show');

}